

(function () {
  "use strict";

  angular.module("WorkerModule", [])

    .factory('WorkerModel', ['$q', function($q) {
      return function(workerPath) {
        var WorkerModel = {};
        var worker = new Worker(workerPath);

        WorkerModel.doWork = function(scopeData, pusherData, itemId, taskName, taskUpdateType) {
          var deferred = $q.defer();
          
          var stringifiedScopeData = JSON.stringify(scopeData);
          worker.postMessage([stringifiedScopeData, pusherData, itemId])
          
          worker.onmessage = function onmessage(postMessage) {
            var workerResponse = {
              list: JSON.parse(postMessage.data),
              taskName: taskName,
              taskUpdateType: taskUpdateType,
              itemId: itemId
            }
            deferred.resolve(workerResponse);
          }
          
          return deferred.promise;
        }
        
        WorkerModel.terminate = function () {
          worker.terminate();
        }

        return WorkerModel;
      }
    }])

    .constant('TaskQueueState', 
      {
        idle: 'idle',
        working: 'working',
        stopped: 'stopped',
        paused: 'paused'
      }
    )

    .factory('TaskQueue', ['TaskQueueState', function(TaskQueueState) {
      return function() {
        var TaskQueue = {
          queue: [],
          state: TaskQueueState.idle
        }

        TaskQueue.setState = function(state) {
          TaskQueue.state = TaskQueueState[state];
        }

        TaskQueue.getState = function() {
          return TaskQueue.state;
        }

        TaskQueue.addTask = function(task) {
          if (task.prioritized) {
            TaskQueue.queue.push(task);
          } else {
            TaskQueue.queue.unshift(task);
          }
        }

        TaskQueue.getTask = function() {
          return TaskQueue.queue.pop();
        }

        TaskQueue.getTasks = function () {
          return TaskQueue.queue;
        }

        TaskQueue.stopQueue = function() {
          TaskQueue.state = TaskQueueState.stopped;
          TaskQueue.queue = [];
        }

        TaskQueue.resetQueue = function () {
          TaskQueue.queue = [];
          TaskQueue.state = TaskQueueState.idle;
        }

        return TaskQueue;

      }
    }])

    .factory('Task', ['$q', function($q){
      return function (taskName, taskUpdateType, workerPath, pusherData, itemId, scopeData, prioritized) {
        var Task = {
          taskName: taskName,
          taskUpdateType: taskUpdateType,
          workerPath: workerPath,
          pusherData: pusherData,
          itemId: itemId,
          scopeData: scopeData ? scopeData : null,
          prioritized: prioritized
        }

        return Task;
      }
    }])

    .service('WorkerThreadpoolService', ['WorkerModel', 'TaskQueue', function(WorkerModel, TaskQueue) {
      var WorkerThreadpool = {
        workers: {},
        queue: new TaskQueue()
      }

        WorkerThreadpool.createWorker = function(puserhReference, workerPath) {
          WorkerThreadpool.workers[puserhReference] = new WorkerModel(workerPath)
        }

        WorkerThreadpool.getWorkers = function() {
          return WorkerThreadpool.workers;
        }

        WorkerThreadpool.terminateWorkers = function() {
          for (var key in WorkerThreadpool.workers) {
            WorkerThreadpool.workers[key].terminate();
            delete WorkerThreadpool.workers[key];
          }
        }

      return WorkerThreadpool;
    }])

    .constant('Workerpool', {
      refreshList: '../admin/worker-files/refreshList.js',
      findAndRefreshList: '../admin/worker-files/isItemOnList.js',
      findAndReplaceItem:  '../admin/worker-files/replaceItemOnList.js',
      printerListUpdatePrinterStatus: '../admin/worker-files/updatePrinterStatus.js',
    })

    .constant('ListControllers', {
      printerList: 'printerList',
      networkList: 'networkList',
      printQueueList: 'printQueueList',
      workstationsList: 'workstationsList', 
      usersList: 'usersList',
      groupsList: 'groupsList'
    })

    .constant('TaskUpdateTypes', {
      refreshList: 'refreshList',
      replaceItem: 'replaceItem',
      silentUpdate: 'silentUpdate'
    })

    .service('EventHandlerService', 
      ['WorkerModel', 'TaskQueue', 'Workerpool', 'EventServiceEvents', '$rootScope', 'Task', 'TaskQueueState',
       'TaskUpdateTypes', 'ListControllers', '$q',
      function(WorkerModel, TaskQueue, Workerpool, EventServiceEvents, $rootScope, Task, TaskQueueState, 
        TaskUpdateTypes, ListControllers, $q) {

      var Threadpool = {
        workers: {},
        queue: new TaskQueue(),
        controllerScope: null,
        controllerScopeData: null,
        listeners: {
          printerListListeners: [],
          networkListListeners: [],
          printQueueListListeners: [],
          workstationListListeners: [],
          userListListeners: [],
          groupListListeners: [],
        }
      }

      Threadpool.init = function() {
        createWorkers();
      }

      Threadpool.setControllerScopeData = function(scope, scopeData) {
        Threadpool.controllerScope = ListControllers[scope];
        Threadpool.controllerScopeData = scopeData;

        Threadpool.deRegisterListeners();
        resetTaskQueue();
      }

      Threadpool.refreshScopeData = function(scope, scopeData) {
        var deferred = $q.defer();
        if (Threadpool.controllerScope === ListControllers[scope]) {
          Threadpool.controllerScopeData = scopeData;
          deferred.resolve();          
        } else {
          deferred.reject();          
        }
        return deferred.promise;
      }
      
      Threadpool.getControllerScope = function () {
        return Threadpool.controllerScope;
      }

      function resetTaskQueue () {
        Threadpool.queue.resetQueue()
      }

      function createWorkers() {
        for (var key in Workerpool) {
          Threadpool.workers[key] = new WorkerModel(Workerpool[key]);
        }
      }
      
      function addTaskToQueue (task) {
        Threadpool.queue.addTask(task);
        
        if (Threadpool.queue.state === TaskQueueState.idle) {
          processTaskQueue();
        }
      } 
      
      function processTaskQueue() {
        function runTasks() {
          var task = Threadpool.queue.getTask();
          if (task && Threadpool.queue.getState() !== TaskQueueState.stopped) {
            Threadpool.queue.setState(TaskQueueState.working);
            var taskWorker = Threadpool.workers[task.workerPath];
            taskWorker.doWork(Threadpool.controllerScopeData, task.pusherData, task.itemId, task.taskName, task.taskUpdateType).then(function(workerResponse) {
              if (workerResponse.list) {
                switch (workerResponse.taskUpdateType) {
                  case 'refreshList':
                    emitUpdateRequestToController(workerResponse.taskUpdateType, workerResponse.taskName);
                  break;
                  case 'replaceItem':
                    emitUpdateRequestToController(workerResponse.taskUpdateType, workerResponse.taskName, workerResponse.itemId);
                  break;
                  case 'silentUpdate':
                    emitUpdateRequestToController(workerResponse.taskUpdateType, workerResponse.taskName, null, workerResponse.list);
                  break;
                }
              }

              if (Threadpool.queue.getTasks().length <= 0) {
                Threadpool.queue.setState(TaskQueueState.idle);
              } else {
                runTasks();
              }
            }).catch(function(error){});
          }
        }

        runTasks();
      }

      function emitUpdateRequestToController(operation, taskName, itemId, list) {
        var updateObject = {
          operation: operation,
          taskName: taskName,
          itemId: itemId ? itemId : null,
          list: list ? list : null,
        } 

        $rootScope.$emit(Threadpool.controllerScope, updateObject); 
      }

      Threadpool.deRegisterListeners = function() {
        for (var key in Threadpool.listeners) {
          for (var i = 0; i < Threadpool.listeners[key].length; i++) {
            Threadpool.listeners[key][i].listener();
          }
        }
        registerListeners();
      }

      function registerListeners() {
        switch(Threadpool.controllerScope) {
          case ListControllers.printerList: 
            registerPrinterListListeners()
          break;
          case ListControllers.networkList:
            registerNetworkListListeners();
          break;
          case ListControllers.printQueueList:
            registerPrintQueueListListeners()
          break;
          case ListControllers.workstationsList:
            registerWorkstationListListeneres();
          break;
          case ListControllers.usersList:
            registerUserListListeners()
          break;
          case ListControllers.groupsList:
            registerGroupListListeners()
          break;
        }
      }

      
      function registerPrinterListListeners () {
        Threadpool.listeners.printerList = [
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.printer, Threadpool.scopeData, true));
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.printer, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function(name, data) {
              if (!data.partOfBatch) {
                if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                  addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.printer, Threadpool.scopeData, true))
                } 
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_STATUS_UPDATE, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.silentUpdate, 'printerListUpdatePrinterStatus', data, data.printer, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BATCH_EXECUTED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped && data.reference === 'PRINTERS_UPDATED_BATCH') {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.printer, Threadpool.scopeData, true));
              }
            })
          }
        ]
      }

      function registerNetworkListListeners () {
        Threadpool.listeners.networkList = [ 
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.network, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.network, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_CHANGED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.network, Threadpool.scopeData, false))
              }
            })
          }
        ]
      }

      function registerPrintQueueListListeners () {

        Threadpool.listeners.printQueueList = [
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.printQueue, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener:  $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.printQueue, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINT_QUEUE_UPDATED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem',  data, data.printQueue, Threadpool.scopeData, false))
              }
            })
          },
          // {
          //   listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_QUEUES_CHANGED, function(){
          //     if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
          //       addTaskToQueue(new Task(name.name, data, data.printQueue, Threadpool.scopeData, false))
          //     }
          //     // $scope.getQueueListPaged();
          //   })
          // },
          // {
          //   listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.BATCH_EXECUTED, function(name, data) {
          //     if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
          //       addTaskToQueue(new Task(name.name, data, data.printQueue, Threadpool.scopeData, true))
          //     }
          //     // if (data.reference === 'PRINT_QUEUES_DELETE_BATCH') {
          //     //   $scope.getQueueListPaged();
          //     // }
          //   })
          // }
        ]
      }

      function registerWorkstationListListeneres () {
        Threadpool.listeners.workstationsList = [
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.workstation, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.workstation, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_UPDATED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.workstation, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.WORKSTATION_NETWORK_CHANGED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.workstation, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.workstation, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_TASK_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.replaceItem, 'findAndReplaceItem', data, data.workstation, Threadpool.scopeData, false))
              }
            })
          }
        ]
      }

      function registerUserListListeners () {
        Threadpool.listeners.usersList = [
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.INVITE_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.invite, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.INVITE_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.invite, Threadpool.scopeData, false))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.USER_ADDED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'refreshList', data, data.user, Threadpool.scopeData, true))
              }
            })
          },
          {
            listener: $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.USER_REMOVED, function(name, data) {
              if (Threadpool.queue.getState() !== TaskQueueState.stopped) {
                addTaskToQueue(new Task(name.name, TaskUpdateTypes.refreshList, 'findAndRefreshList', data, data.user, Threadpool.scopeData, true))
              }
            })
          }
        ]
     
      }

      function registerGroupListListeners () {
        // NO listeners defined yet
      }

      Threadpool.init();
      delete Threadpool.init;
      return Threadpool;

    }])
})();